document.addEventListener('DOMContentLoaded', function () {
  const rolexPlaque = document.querySelector('.rolex-retailer-clock');

  if (rolexPlaque) {
    // Create an invisible overlay link
    const linkOverlay = document.createElement('a');
    linkOverlay.href = '/pages/discover-rolex';
    linkOverlay.style.position = 'absolute';
    linkOverlay.style.top = 0;
    linkOverlay.style.left = 0;
    linkOverlay.style.width = '100%';
    linkOverlay.style.height = '100%';
    linkOverlay.style.zIndex = 10;
    linkOverlay.style.display = 'block';
    linkOverlay.style.cursor = 'pointer';
    linkOverlay.style.background = 'transparent';

    // Make sure parent is positioned
    rolexPlaque.style.position = 'relative';
    rolexPlaque.appendChild(linkOverlay);
  }
});